module.exports = __webpack_public_path__ + "assets/img/fangan03.3821f06b.png";